class CoreHeaderController {
    constructor($window, shopperService, shopPageStateService, moveFocus, analyticsService, settings, trolleyService, breakpointsService) {
        this.$window = $window;
        this.shopperService = shopperService;
        this.shopPageStateService = shopPageStateService;
        this.moveFocus = moveFocus;
        this.analyticsService = analyticsService;
        this.settings = settings;
        this.trolleyService = trolleyService;
        this.breakpointsService = breakpointsService;
    }

    $onInit() {
        this.sfSearchActive = false;
        // eslint-disable-next-line no-undef
        this.imagesPath = IMAGES_PATH;
        // eslint-disable-next-line no-undef
        this.isB2b = (IS_B2B.trim() === 'TRUE');
    }

    isMenuOpen() {
        return this.shopPageStateService.smallFormatMenuOpen;
    }

    toggleOffscreenMenu(isOpen = !this.shopPageStateService.smallFormatMenuOpen) {
        this.shopPageStateService.smallFormatMenuOpen = isOpen;

        if (this.shopPageStateService.smallFormatMenuOpen) {
            this.moveFocus('#smallMenu');
        }
    }

    hideMenu() {
        if (this.isMenuOpen()) {
            this.toggleOffscreenMenu();
        }
    }

    pushToAnalytics() {
        this.analyticsService.push({
            data: {
                event: {
                    category: 'HomePageIcon',
                    value: this.$window.location.origin,
                    label: 'homepage icon',
                },
                trackingType: 'link',
            },
            type: this.analyticsService.mapperTypes.customEvent.linkClick,
        });
    }
}

const coreHeaderComponentDefinition = {
    controller: ['$window', 'ShopperService', 'ShopPageStateService', 'MoveFocus', 'AnalyticsService', 'Settings', 'TrolleyService', 'BreakpointsService', CoreHeaderController],
    template: require('./core-header.component.html').trim(),
};

module.exports = {
    CoreHeaderController,
    coreHeaderComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/header/core-header.component.js